import "./style.css";

import "js-datepicker/dist/datepicker.min.css";
import datepicker from "js-datepicker";

export default class Select {
  static selector = ".select";

  constructor(block) {
    this.block = block;

    this.block.component = this;

    this.label = this.block.querySelector(".select__label");
    this.label.addEventListener("click", this.onClick);

    this.initItems();

    if (this.isDate(this.block)) {
      if (!("ontouchstart" in window)) {
        this.input.setAttribute("type", "text");
      }
      datepicker(this.input, {
        disableMobile: true,
        onSelect: this.onChange,
        formatter: this.dateFormatter,
        showAllDates: true
      });
    }
  }

  isDate = el => this.block.classList.contains("select__date");

  onClick = e => {
    e.stopPropagation();
    if (this.block.classList.contains("open")) {
      this.close(this.block);
    } else {
      this.open(this.block);
    }
  };

  open = el => {
    if (el.classList.contains("disabled")) {
      const error = el.querySelector(".select__error");
      if (error) {
        error.classList.add("show");
      }
      return;
    }

    this.closeAllSelect(el);

    el.classList.add("open");
    if (this.isDate(el)) {
      const input = el.querySelector("input");
      input.focus();
    }

    window.addEventListener("click", this.onWindowClicked);
  };

  onWindowClicked = e => {
    let targetElement = e.target;

    do {
      if (targetElement === this.block) {
        return;
      }

      if (
        targetElement.parentNode === null &&
        targetElement.classList !== undefined &&
        (targetElement.classList.contains("qs-controls") ||
          targetElement.classList.contains("qs-overlay"))
      ) {
        return;
      }

      targetElement = targetElement.parentNode;
    } while (targetElement);

    this.close(this.block);
  };

  close = el => {
    el.classList.remove("open");
    const error = el.querySelector(".select__error");
    if (error) {
      error.classList.remove("show");
    }
    if (this.isDate(el)) {
      const input = el.querySelector("input");
      input.blur();
    }

    window.removeEventListener("click", this.onWindowClicked);
  };

  closeAllSelect = el => {
    const selects = [...document.querySelectorAll(".select")];

    selects.forEach(s => {
      if (!s.contains(el) && s != el && s.component) {
        s.component.close(s);
      }
    });
  };

  onChange = () => {
    this.label.innerText = this.input.value;
    var event = new CustomEvent("input");
    this.input.dispatchEvent(event);
  };

  dateFormatter = (input, date) => {
    input.value = `${date.getDate()}/${date.getMonth() +
      1}/${date.getFullYear()}`;
  };

  initItems = () => {
    this.input = this.block.querySelector("input, select");

    if (this.input && !this.input.classList.contains("not-change")) {
      this.input.removeEventListener("change", this.onChange);
      this.input.addEventListener("change", this.onChange);
    }

    this.items = [
      ...this.block.querySelector(".select__dropdown").childNodes
    ].filter(el => el.classList && el.classList.contains("select__item"));

    this.items.forEach(el => {
      el.removeEventListener("click", this.onItemSelect);
      el.addEventListener("click", this.onItemSelect);
    });
  };

  onItemSelect = e => {
    e.preventDefault();
    this.close(this.block);
    this.items.forEach(item => {
      if (item == e.currentTarget) {
        if (!item.classList.contains("selected")) {
          item.classList.add("selected");
          this.label.innerText = item.innerText;
          this.input.value = e.currentTarget.getAttribute("data-value");
        } else {
          item.classList.remove("selected");
          this.label.innerText = this.block.getAttribute("data-placeholder");
          this.input.value = "";
        }
      } else {
        item.classList.remove("selected");
      }
    });

    var event = new CustomEvent("input");
    this.input.dispatchEvent(event);
  };
}
